import {
  ContentfulSearchResult,
  ContentfulSearchResultContentType,
} from "../models/contentful"

export const sortSearchResults = (searchResults: ContentfulSearchResult[]) => {
  return searchResults.sort((a, b) => {
    return a["content-type"].localeCompare(b["content-type"])
  })
}

export const getSearchResultLink = (searchResult: ContentfulSearchResult) => {
  if (
    searchResult["content-type"] ===
    ContentfulSearchResultContentType.HelpCenterArticle
  ) {
    return `/articles/${searchResult["contentful-id"]}`
  } else if (
    searchResult["content-type"] === ContentfulSearchResultContentType.Category
  ) {
    return `/${searchResult.slug}`
  }
  return "/"
}
